var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.$store.getters.getSiteInfo.logal}}),_c('h2',{style:(_vm.font)},[_vm._v(_vm._s(_vm.$store.getters.getSiteInfo.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }